import { Divider } from "@material-ui/core";
import React from "react";
import Styles from "../../scss/orderDetails.module.scss";
import VStyles from "../../scss/voidOrderDialog.module.scss"
import { ReactComponent as CloseSVG } from "../../assets/images/icon-orange-x-page.svg";

import Dialog from "../Dialog";
import { useTranslation } from "react-i18next";

interface IDialogSaveChangesProps {
    isOpen: boolean;
    onClose: () => void;
    onCloseAll: () => void;
}

export function DialogSaveChanges({
    onClose,
    isOpen,
    onCloseAll
}: IDialogSaveChangesProps) {
    const { t } = useTranslation();
    return <Dialog
        title={<div className={Styles.ActionMessages}>
            <CloseSVG />
            <p style={{ color: "#212121" }}>
                {t('dialog.ChangedDialog.title')}
            </p>
        </div>}
        onClose={onClose}
        canClose={true}
        isOpen={isOpen}
        styles={{ className: Styles.FinishAllDialog }}
    >
        <div className={VStyles.VoidOrderDialogContainer}>
            <Divider />
            <div className={VStyles.Controllers}>
                <div>
                    <p>
                        {t('dialog.ChangedDialog.info')}
                    </p>
                </div>
                <div>
                    <div onClick={onClose}>
                        <p>{t('delete.cancel')}</p>
                    </div>
                    <div onClick={onCloseAll}>
                        <p>{t('delete.confirm')}</p>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
}